import {
  OreButton,
  OreIcon,
  OreNavBarHeader,
  SvgNavBarHelp,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { LoginTranslation } from '@/Account/ui/accountTranslation'
import { SITE_INFO } from '@/Shared/constants/siteInfo'
import { openNavigationRoutes } from '@/Shared/ui/routers/data/navigationRoutes'

import '../assets/login.css'
import { LangSelector } from '../molecules'
import { KebabMenu } from '../molecules'

export const Navbar = () => {
  const { t } = useTranslation()

  const routesWithLoginSubject = new Set<string>([
    openNavigationRoutes.login,
    openNavigationRoutes.otpAuth,
    openNavigationRoutes.registerStepOne,
    openNavigationRoutes.registerStepTwo,
    openNavigationRoutes.registerStepThree,
    openNavigationRoutes.registerEmailSuccess,
    openNavigationRoutes.passwordRecoveryStep1,
    openNavigationRoutes.passwordRecoveryStep2,
    openNavigationRoutes.passwordRecoveryEmailSuccess,
    openNavigationRoutes.passwordRecoveryPasswordChangeSuccess,
    openNavigationRoutes.passwordRecoveryPasswordChangeError,
    openNavigationRoutes.otp,
  ])

  const handleHelpClick = () => {
    const currentPath = globalThis.location.pathname
    const includeSubject = routesWithLoginSubject.has(currentPath)

    const mailtoBase = `mailto:${SITE_INFO.contact.email}`
    const mailtoUrl = includeSubject
      ? `${mailtoBase}?subject=${t(LoginTranslation.navbar.mailtoButton.subject)}`
      : mailtoBase
    globalThis.location.href = mailtoUrl
  }

  return (
    <OreNavBarHeader>
      <OreButton onClick={handleHelpClick} category="tertiary">
        <OreIcon tone={'ternary'} size={'extra-small'} icon={<SvgNavBarHelp />} />
      </OreButton>
      <LangSelector />
      <div className="navbar-divider"></div>
      <KebabMenu />
    </OreNavBarHeader>
  )
}
